export const NavigationTileDescriptiveLayout = {
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1,
}
export const CONSTANTS = {
  DELETE_PARAMS: 'delete_params',
  HEADINGS: {
    TELSTRACONNECT: 'Telstra Connect',
    NETWORKSANDINTERNET: 'Networks and internet',
    PRODUCTSANDSERVICES: 'Products and services',
    DASHBOARD: 'Dashboard',
  },
  NAV_ITEMS: {
    SERVICES_MAP: {
      ID: 'services_map',
      LABEL: 'Services map',
    },
    SERVICES_LIST: {
      ID: 'services_list',
      LABEL: 'Services list',
    },
    MAKE_AN_UPDATE: {
      ID: 'Make_an_update',
      LABEL: 'Make an update',
      SUBTITLE: 'If you have a Telstra partner, please contact them to create a request.',
    },
    INCIDENTS: {
      ID: 'Incidents',
      LABEL: 'Incidents',
    },
    HELP_AND_SUPPORT: {
      ID: 'Help_and_support',
      LABEL: 'Help and support',
    },
  },
  CREATE_REQUEST: {
    description: 'Make updates to your existing services.',
    picto: 'Chat56',
    title: 'Create Request',
  },
  TRACK_REQUESTS: {
    description: 'View all requests.',
    picto: 'Chat56',
    title: 'Track requests',
  },
  CREATE_INCIDENT: {
    description: 'Report incidents and outages.',
    picto: 'Warning56',
    title: 'Create incident',
  },
  TRACK_INCIDENTS: {
    description: 'View all incidents.',
    picto: 'Warning56',
    title: 'Track incidents',
  },
  FAQ: 'Frequently asked questions',
  SUPPORT_CREATE_ENQ: 'Raise support enquiries',
  SUPPORT_TRACK_ENQ: 'Track support enquiries',
  PLANNED_MAINTENANCE: 'Planned maintenance',
  BANNER: {
    ACTION_TEXT: 'Check for planned maintenance',
    TITLE_TEXT: `We're making some planned changes`,
  },
  PLANNED_MAINTENANCE_DESC: `During this time you might not be viewing your latest network and internet services. We're working hard to fix this issue.`,
  DATA_QUALITY_DESC:
    'We are aware that you might not be seeing the most up-to-date view of your networks and internet products. Please be patient while we uplift our data.',
}
